import getStylesToUpdate from './get-styles-to-update';
import checkIfRowHasColumns from './check-if-row-has-columns';

export { getStylesToUpdate, checkIfRowHasColumns };
